export default __webpack_public_path__ + "static/media/cards.df8c3d73.png";